import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormButtonComponent } from 'Shared/app/components/wfs-form-button/form-button.component';

export interface ErrorModalData {
  title?: string;
  message?: string;
  subMessage?: string;
  confirmText?: string;
  denyText?: string;
  buttonStyles?: Record<string, string>;
  revertButtons?: boolean;
  useDefault?: boolean;
}

@Component({
  selector: 'wfs-new-error-modal',
  templateUrl: './new-error-modal.component.html',
  styleUrls: ['./new-error-modal.component.scss'],
  imports: [CommonModule, FormButtonComponent, MatDialogModule],
  encapsulation: ViewEncapsulation.None
})
export class NewErrorModalComponent {
  readonly data = inject<ErrorModalData>(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef);

  readonly revertButtons = this.data.revertButtons ?? false;
  readonly useDefault = this.data.useDefault ?? true;

  triggerEvent(value: boolean): void {
    this.#dialogRef.close(value);
  }
}
